<template>
  <div class="collectionBox">
    <viewHeader></viewHeader>
    <div
      class="content"
      v-loading.fullscreen="loading"
      element-loading-text="拼命加载中"
    >
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <img src="../assets/img/collection1.png" alt="" class="L" />
          <span class="L">我的收藏</span>
          <div class="tab-list-box">
            <p v-for="(item,index) in tabs" :key="index" :class="{ active : activeName == item.name}" @click="handleSwitchTab(item)"><span>{{ item.label }}</span><em></em></p>
          </div>
        </div>
        <div class="collection-box">
          <div class="literature-box" v-show="hasData && activeName == 'literature'">
            <div class="resultList">
              <el-timeline :reverse="reverse">
                <el-timeline-item
                  :color="color"
                  v-for="(value, index) in timeData"
                  :key="index"
                >
                  <p class="timeLine">{{ index }}</p>
                  <ul>
                    <li
                      v-for="(item, index1) in value"
                      :key="index1"
                      class="infoLi"
                      v-loading="item.loading"
                    >
                      <el-row :gutter="20" class="listTitle">
                        <el-col :span="14" class="title">
                          {{item.title_en}}
                          <img v-show="item.is_download" class="pptIcon" src="../assets/img/ppt.png" alt="">
                        </el-col>
                        <el-col
                          :span="5"
                          class="YXYZ clearfix"
                          v-if="item.impact_factor && item.impact_factor !== ''"
                        >
                          <img src="../assets/img/icon6.png" alt="" class="L" />
                          <span class="L">影响因子：{{ item.impact_factor }}</span>
                        </el-col>
                      </el-row>
                      <div class="tags">
                        <articleTags :pubdate="item.pubdate_show" :language="item.language" :pubType="item.pub_type"></articleTags>
                      </div>
                      <el-row class="listInfo">
                        <el-col :span="10"
                          ><span>PMID：</span>{{ item.pmid }}</el-col
                        >
                        <el-col v-if="item.doi" :span="10"
                          ><span>DOI：</span>{{ item.doi }}</el-col
                        >
                        <el-col :span="20"
                          ><span>期刊：</span>{{ item.journal_name }}</el-col
                        >
                        <!-- <el-col :span="20"
                          ><span>发表时间：</span>{{ item.pubdate_show }}</el-col
                        > -->
                        <el-col
                          :span="20"
                          v-if="
                            item.keyword_categories &&
                            item.keyword_categories['Diseases']
                          "
                        >
                          <span>疾病：</span>
                          <em
                            v-for="(disease, disIndex) in item.keyword_categories[
                              'Diseases'
                            ]"
                            :key="disIndex"
                            >{{ disease[0] + "(" + disease[1] + ")"
                            }}<i
                              v-if="
                                disIndex + 1 <
                                item.keyword_categories['Diseases'].length
                              "
                            >
                              、</i
                            ></em
                          >
                        </el-col>
                        <el-col
                          :span="20"
                          v-if="item.keyword_categories && item.keyword_categories['Drugs and Chemicals']"
                        >
                          <span>药品：</span>
                          <em
                            v-for="(drug, drugIndex) in item.keyword_categories[
                              'Drugs and Chemicals'
                            ]"
                            :key="drugIndex"
                            >{{ drug[0] + "(" + drug[1] + ")"
                            }}<i
                              v-if="
                                drugIndex + 1 <
                                item.keyword_categories['Drugs and Chemicals']
                                  .length
                              "
                            >
                              、</i
                            ></em
                          >
                        </el-col>
                        <el-col
                          :span="20"
                          v-if="
                            item.keyword_categories &&
                            item.keyword_categories['Geographic Locations']
                          "
                        >
                          <span>地理位置：</span>
                          <em
                            v-for="(location, locationIndex) in item
                              .keyword_categories['Geographic Locations']"
                            :key="locationIndex"
                            >{{ location[0] + "(" + location[1] + ")"
                            }}<i
                              v-if="
                                locationIndex + 1 <
                                item.keyword_categories['Geographic Locations']
                                  .length
                              "
                            >
                              、</i
                            ></em
                          >
                        </el-col>
                        <!-- 隐藏研究背景，研究目的，研究结论 添加important_message字段 2021-01-05 qinrui-->
                        <!-- <el-col :span="20" v-if="item.key_information"> -->
                        <el-col :span="20" v-if="item.important_message && item.important_message.length != 0">
                          <span>重点信息：</span>
                          <div :class="item.key_height">
                            <p class="key_infor" v-for="(important, importantIndex) in item.important_message" :key="'重点信息' + importantIndex">
                              {{ `● ${important}` }}
                            </p>
                            <!-- <p
                              class="key_infor"
                              v-if="
                                item.key_information[0] &&
                                item.key_information[0][1] !== ''
                              "
                            >
                              <span>研究背景：</span
                              >{{ item.key_information[0][1] }}
                            </p>
                            <p
                              class="key_infor"
                              v-if="
                                item.key_information[1] &&
                                item.key_information[1][1] !== ''
                              "
                            >
                              <span>研究目的：</span
                              >{{ item.key_information[1][1] }}
                            </p>
                            <p
                              class="key_infor"
                              v-if="
                                item.key_information[4] &&
                                item.key_information[4][1] !== ''
                              "
                            >
                              <span>研究结论：</span
                              >{{ item.key_information[4][1] }}
                            </p> -->
                          </div>
                          <em
                            class="R down"
                            :class="
                              item.key_height === 'initHeight'
                                ? 'el-icon-arrow-down'
                                : 'el-icon-arrow-up'
                            "
                            @click="showFull(item.key_height, index, index1)"
                          ></em>
                        </el-col>
                      </el-row>
                      <div class="action">
                        <a
                          href="javascript:;"
                          class="translate"
                          @click="
                            translateFullText(
                              item.pmid,
                              index,
                              index1,
                              item.translate
                            )
                          "
                          title="翻译"
                        ></a>
                        <a
                          href="javascript:;"
                          class="fullText"
                          @click="showFullText(item.pmid)"
                          title="查看全文"
                        ></a>
                        <a
                          href="javascript::"
                          class="collection"
                          :class="
                            item.is_collected ? 'collectionTrue' : 'collection'
                          "
                          @click="collection(item.pmid, index, index1)"
                          title="收藏"
                        ></a>
                        <!-- <a href="javascript:;" class="share" title="分享"></a> -->
                      </div>
                    </li>
                  </ul>
                </el-timeline-item>
              </el-timeline>
            </div>
            <el-pagination
              v-show="isShow"
              background
              :hide-on-single-page="true"
              :current-page="pageNum"
              :page-size="10"
              @current-change="handleCurrentChange"
              layout="prev, pager, next"
              :total="totalNum"
            >
            </el-pagination>
            <div class="noData" v-show="!hasData">
              <img src="../assets/img/empty.png" alt="" />
              <span>空空如也，没有收藏任何文献哦~</span>
            </div>
          </div>
          <!-- 病例列表 -->
          <div class="case-box" v-if="hasCaseData && activeName == 'case'">
            <caseCollection @hideOrShowCase="hideOrShowCase"></caseCollection>
            <div class="noData" v-show="!hasCaseData">
              <img src="../assets/img/empty.png" alt="" />
              <span>空空如也，没有收藏任何病例哦~</span>
            </div>
          </div>
          <!-- 研究列表 -->
          <div class="case-box" v-if="activeName == 'clinical'">
            <TrialCollectionItem></TrialCollectionItem>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { md5 } from "md5js";
import viewHeader from "./viewHeader";
import articleTags from '../components/articleTags'
import { translateInfo, collection } from "../service/getData";
import { webTrackerEvent } from "../utils/tracker";
import caseCollection from "@/components/case/collection.vue"
import TrialCollectionItem from '../components/TrialCollectionItem.vue'
export default {
  name: "collection",
  components: {
    viewHeader,
    articleTags,
    caseCollection,
    TrialCollectionItem
  },
  data() {
    return {
      tabs: [{ label: "文献", name: "literature" },{ label: "病例", name: "case" },{ label: "研究", name: "clinical" }],
      hasData: true,
      hasCaseData: true,
      secret: "4ede4aafbzd51cbz3e32bzb781bzee9813d17154",
      clientId: "zeta",
      loading: true,
      reverse: false,
      color: "#6a9edd",
      timeData: {},
      titleJson: {},
      importantJson: {}, // 重点信息
      pageSize: 10,
      pageNum: 1,
      isShow: false,
      totalNum: 0,
      token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
      openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
      activeName: 'literature',
      currentPageUrl: '', // 当前页面url
    };
  },
  methods: {
     /**
     * 切换顶部tab
     */
    handleSwitchTab(item) {
      this.activeName = item.name
    },
    // 显示或隐藏病例数据
    hideOrShowCase(data) {
      this.hasCaseData = data
    },
    async getCollection() {
      const params = {
        limit: this.pageSize,
        page: this.pageNum,
      };
      const res = await collection("GET", params);
      if (res && res.data.status === 0) {
        this.isShow = true;
        this.totalNum = res.data.count;
        this.loading = false;
        this.timeData = {};
        this.titleJson = {};
        if (res.data.data.length === 0) {
          this.hasData = false;
          return;
        }
        res.data.data.forEach((item) => {
          const collect_date = item.collect_time.substring(0, 10);
          if (item.pubdate_show) {
            // item.pubdate_show = item.pubdate_show.substring(0, 10);
            item.loading = false;
          }
          item.key_height = "initHeight";
          item.translate = false;

          this.timeData[collect_date] = [];
          this.titleJson[collect_date] = [];
          this.importantJson[collect_date] = [];
        });
        res.data.data.forEach((item) => {
          const collect_date = item.collect_time.substring(0, 10);
          if (this.timeData[collect_date]) {
            this.timeData[collect_date].push(item);
            this.titleJson[collect_date].push(item.title_en);
            this.importantJson[collect_date].push(item.important_message);
          }
        });
      } else {
        this.isShow = false;
        this.loading = false;
        this.hasData = false;
      }
    },
    // 翻译重点信息
    async translateFullText(pmid, index, index1, translate) {
      let key_type = "";
      let current = this.timeData[index];
      current[index1].loading = true;
      if (translate) {
        current[index1].title_en = this.titleJson[index][index1];
        current[index1].important_message = this.importantJson[index][index1];
        key_type = "en_key";
      } else {
        key_type = "cn_key";
      }
      let ts = new Date().getTime();
      let tokenStr = `${this.clientId}.bz${ts}.bz${pmid}.bz${this.secret}`;
      let token = md5(tokenStr, 32);
      const params = {
        client_id: this.clientId,
        ts: Number(ts),
        pmid: String(pmid),
        types: key_type,
        token: token,
      };
      const res = await translateInfo(params);

      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "translate");
      Logger.push("language", key_type);
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (res.data.status === 0) {
        if (!translate) {
          current[index1].title_en = res.data.data.title;
          current[index1].key_information = res.data.data.sentence;
          current[index1].important_message = res.data.data.important_message;
          current[index1].translate = true;
          current[index1].loading = false;
          this.timeData[index] = current;

          this.timeData = Object.assign({}, this.timeData);
          return;
        }
        current[index1].key_information = res.data.data.sentence;
        current[index1].translate = false;
        current[index1].loading = false;
        this.timeData[index] = current;

        this.timeData = Object.assign({}, this.timeData);
      }
    },
    // 展开全文
    showFull(key_height, index, index1) {
      let current = this.timeData[index];
      if (key_height === "initHeight") {
        current[index1]["key_height"] = "autoHeight";
      } else {
        current[index1]["key_height"] = "initHeight";
      }
      this.timeData[index] = current;
      this.timeData = Object.assign({}, this.timeData);
    },
    // 分页
    handleCurrentChange(val) {
      this.loading = true;
      this.pageNum = val;
      window.scroll(0, 0);
      this.getCollection();
    },
    // 查看全文
    showFullText(pmid) {
      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "fullText");
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();
      const { href } = this.$router.resolve({
        name: "fullText",
        path: "/fullText",
        query: {
          pmid: pmid
        },
      });
      window.open(href);
      // this.$router.push("fullText?pmid=" + pmid);
    },
    // 取消收藏
    async collection(pmid, index, index1) {
      let current = this.timeData[index];
      const res = await collection("DELETE", { pmid: pmid });

      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "delete_collection");
      Logger.push("pmid", pmid);
      Logger.push("token", this.token);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (res.data.status === 0) {
        this.timeData[index].splice(index1, 1);
        if (this.timeData[index].length === 0) {
          delete this.timeData[index];
        }
        this.timeData = Object.assign({}, this.timeData);
      } else {
        this.$message({
          message: "取消失败，请重试",
          type: "error",
        });
      }
    },
  },
  destroyed () {
    let Logger = webTrackerEvent();
    Logger.push("eventType", "pageUnload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", this.currentPageUrl);
    Logger.logger();
  },
  created() {
    this.currentPageUrl = window.location.href;
    let Logger = webTrackerEvent();
    Logger.push("eventType", "pageload");
    Logger.push("timeStamp", new Date().getTime());
    Logger.push("token", this.token);
    Logger.push("openid", this.openid);
    Logger.push("pageUrl", window.location.href);
    Logger.logger();
    this.getCollection();
  },
};
</script>

<style scoped lang="less">
.collectionBox {
  background: #f9f9f9;
  min-height: 700px;
}
.collectionBox .content {
  width: 1080px;
  margin: 0 auto;
  /deep/.el-card__header{
    position: relative;
    .tab-list-box{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      p{
        width: 50px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        span{
          font-size: 14px;
          color: #666;
          font-weight: normal;
        }
        em{
          width: 30px;
          height: 2px;
          background: #387ED2;
          margin: 0 auto;
          margin-top: 8px;
          opacity: 0;
        }
        &.active{
          span{
            color: #387ED2;
          }
          em{
            opacity: 1;
          }
        }
      }
    }
  }
}
.collectionBox .content .el-card__header span {
  margin-left: 10px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.collectionBox .content .resultList {
  width: 1000px;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 14px;
  color: #333;
  /* border:1px solid #ccc; */
  border-bottom: none;
}
.collectionBox .content .resultList ul li.infoLi {
  border: 1px solid #ccc;
  margin-top: -1px;
  padding: 10px;
  position: relative;
  overflow: hidden;
}
.collectionBox .content ul li.el-timeline-item {
  padding: 0;
  border: none;
  margin-bottom: 30px;
  /* overflow:visible; */
}
.collectionBox .content .resultList ul li.el-timeline-item p.timeLine {
  font-size: 14px;
  color: #4586d5;
  padding-left: 24px;
  background: url("../assets/img/collection2.png") no-repeat 0 center;
  margin-bottom: 10px;
}
.collectionBox .content .resultList .tags {
  margin-top: 10px;
}
.collectionBox .content .resultList .listTitle .title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.collectionBox .content .resultList .listTitle .title .pptIcon {
  width: 20px;
  vertical-align: middle;
}
.collectionBox .content .resultList .listTitle .YXYZ span {
  // line-height: 30px;
  margin-left: 10px;
}
.collectionBox .content .resultList .listTitle .RGBZ span {
  line-height: 30px;
  margin-left: 10px;
}
.collectionBox .content .resultList .listTitle .YXYZ img {
  width: 15px;
  height: 15px;
  margin-top: 2px;
}
.collectionBox .content .resultList .listTitle .RGBZ img {
  width: 17px;
  height: 20px;
  margin-top: 5px;
}
.collectionBox .content .resultList .listInfo {
  margin-top: 10px;
}
.collectionBox .content .resultList .listInfo .el-col {
  margin-bottom: 10px;
}
.collectionBox .content .resultList .listInfo .el-col span {
  color: #387ed2;
}
.collectionBox .content .resultList .listInfo .initHeight {
  height: 30px;
  overflow: hidden;
}
.collectionBox .content .resultList .listInfo em.down {
  /* background:#387ed2;
        border:none;
        padding:5px 10px;
        color:#fff;
        border-radius: 10px; */
  margin-top: 5px;
  font-size: 24px;
  position: relative;
  top: -24px;
  right: -60px;
  cursor: pointer;
}
.collectionBox .content .resultList .listInfo .autoHeight {
  height: auto;
}
.collectionBox .content .resultList .listInfo .el-col .key_infor {
  margin-top: 10px;
  line-height: 25px;
}
.collectionBox .content .resultList .action {
  width: 50px;
  height: 100%;
  border-left: 1px solid #ccc;
  position: absolute;
  top: 0;
  right: 0;
  background: #f5f5f5;
  /* padding-top: 26px; */
}
.collectionBox .content .resultList .action a {
  display: block;
  height: 33.3%;
}
.collectionBox .content .resultList .action a.translate {
  background: url("../assets/img/icon1.png") no-repeat center center;
}
.collectionBox .content .resultList .action a.fullText {
  background: url("../assets/img/icon2.png") no-repeat center center;
}
.collectionBox .content .resultList .action a.collection {
  background: url("../assets/img/icon3.png") no-repeat center center;
}
.collectionBox .content .resultList .action a.collectionTrue {
  background: url("../assets/img/icon3_01.png") no-repeat center center;
}
.collectionBox .content .resultList .action a.share {
  background: url("../assets/img/icon4.png") no-repeat center center;
}
.collectionBox .content .resultList .action a:hover {
  background-color: #387ed2;
}
.collectionBox .content .resultList .action a.translate:hover {
  background-image: url("../assets/img/icon1_01.png");
}
.collectionBox .content .resultList .action a.fullText:hover {
  background-image: url("../assets/img/icon2_01.png");
}
.collectionBox .content .resultList .action a.collection:hover {
  background-image: url("../assets/img/icon3_02.png");
}
.collectionBox .content .resultList .action a.share:hover {
  background-image: url("../assets/img/icon4_01.png");
}
.collectionBox .content .el-pagination {
  margin-top: 30px;
  text-align: center;
}
.collectionBox .noData {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.collectionBox .noData img {
  display: block;
  margin: 0 auto;
}
.collectionBox .noData span {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
}
/* .collectionBox .content .resultList .action a img{
    width: 18px;
    height: 18px;
    display: block;
    margin: 0 auto;
}
.collectionBox .content .resultList .action a img.fullText{
    width: 20px;
} */
</style>
<style>
.el-tabs__content{
  min-height: 140px;
}
.el-card__body{
  padding: 15px !important;
}
.collectionBox .content ul li.el-timeline-item .el-timeline-item__wrapper {
  padding: 0 !important;
}
.collectionBox .content .el-timeline-item__node--normal {
  left: -21px;
}
.collectionBox .content .literature-box .el-timeline-item__tail {
  left: -16px;
  height: 108%;
  border: 1px dashed #ebebeb;
}
</style>


// WEBPACK FOOTER //
// src/views/collection.vue